import { render, staticRenderFns } from "./Pick.vue?vue&type=template&id=7c62cf20&scoped=true&"
import script from "./Pick.vue?vue&type=script&lang=js&"
export * from "./Pick.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c62cf20",
  null
  
)

export default component.exports